import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { AuthoritiesQuery as AuthoritiesQueryType, AuthoritiesQueryVariables } from "./__generated__/AuthoritiesQuery";

const AuthoritiesQuery = loader("./AuthoritiesQuery.gql");

type AuthoritiesQueryProviderType = (props: {
  children: (data: AuthoritiesQueryType) => ReactNode;
  variables?: AuthoritiesQueryVariables;
}) => ReactElement;

export const AuthoritiesQueryProvider: AuthoritiesQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<AuthoritiesQueryType, AuthoritiesQueryVariables>(AuthoritiesQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
